import h from "./html";
import Db from "./db";

export default function ImportIcs({
  db,
  selectedCalendarsJson,
  expanded,
}: {
  db: Db;
  selectedCalendarsJson: h.State<string>;
  expanded: h.State<boolean>;
}) {
  const dragging = h.state(false);

  return (
    <div
      className={() =>
        `flex-grow content-center rounded-lg border-2 border-dashed border-blue-500 py-12 text-center ${dragging.val ? "bg-blue-200" : ""}`
      }
      ondragover={(ev) => {
        ev.preventDefault();
        dragging.val = true;
      }}
      ondragleave={(ev) => {
        ev.preventDefault();
        dragging.val = false;
      }}
      ondrop={async (ev: DragEvent) => {
        ev.preventDefault();
        dragging.val = false;
        for (const item of [...(ev.dataTransfer?.items ?? [])]) {
          console.log("mut", item.kind, item.type);
          if (item.kind === "file" && item.type === "text/calendar") {
            let f: File | null;
            if ((f = item.getAsFile())) {
              const data = await f.arrayBuffer();
              const [[calendarId]] = await db.mutate(
                /* sql */
                `
                  INSERT INTO
                    icalendar
                  VALUES
                    (NULL, ?1) RETURNING calendar_id
                `,
                f.name,
              );
              selectedCalendarsJson.val = JSON.stringify([
                ...JSON.parse(selectedCalendarsJson.val).filter(
                  (id: number) => id !== calendarId,
                ),
                calendarId,
              ]);

              await db.mutate(
                /* sql */
                `
                  INSERT INTO
                    icalendar_entry
                  select
                    ?1,
                    entry_id,
                    parent_id,
                    name,
                    value,
                    type
                  FROM
                    icalendar_tree (?2)
                `,
                calendarId,
                data,
              );

              expanded.val = false;
            }
          }
        }
      }}
    >
      Drag an ics file here to import it.
    </div>
  );
}
